<template>
  <div class="container-tag" :class="(state === 1) ? 'active' : 'inactive'">
    <h1>{{ data }}</h1>
  </div>
</template>

<script>
export default {
	props: {
		state: {
			type: Number,
			default: 0,
		},
		data: {
			type: String,
			default: '',
		},
		align: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss">

.container-tag {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 2px 10px 2px 10px;
  justify-content: center;
  justify-self: center;
  max-width: 120px;
  cursor: pointer;
  align-self: center;
}
.container-tag h1 {
      font-weight: bold;
        font-size: 10px;
}
.inactive {
  background-color:rgba(255, 159, 67,.15);
  color: #ff9f43;
}
.active {
  background-color: #cdffcd;
  color: #007f00;
}

.circle-active {
 background-color: #007f00;
}
.circle-inactive {
 background-color: #ff9f43;
}

</style>
